import { render, staticRenderFns } from "./addclaimaa.vue?vue&type=template&id=49f4cc94&scoped=true&"
import script from "./addclaimaa.vue?vue&type=script&lang=js&"
export * from "./addclaimaa.vue?vue&type=script&lang=js&"
import style0 from "./addclaimaa.vue?vue&type=style&index=0&id=49f4cc94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4cc94",
  null
  
)

export default component.exports